module.exports = __webpack_public_path__ + "static/media/SingleCoupon_default.368f691b.png";